import classNames from 'classnames';

import type {UserStatus} from '../../../../types/general';

import styles from './styles.module.css';

type Props = {
    status: UserStatus;
    className?: string;
};

const statusClassnameMap: Record<UserStatus, string> = {
    online: styles.online,
    offline: styles.offline,
    away: styles.away,
    dnd: styles.dnd,
};

export const StatusIcon = ({status, className}: Props) => {
    return <span className={classNames(className, styles.statusIcon, statusClassnameMap[status])} />;
};
